import moment from 'moment';
import * as React from 'react';
import { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import ContractOwnershipList from 'src/models/ContractOwnershipList';
import Card from 'src/components/common/Card.redesign';
import AgreementUtil from 'src/util/AgreementUtil';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';

interface IAttachedAgreementsProps {
    attachedAgreements: Array<ContractOwnershipList>;
    ownerLookupId?: number;
    shortList?: boolean;

    navToLeasehold: (ownershipId: number, contractId: number, contractholdId: number, contractType: string) => void;
}

const AttachedAgreements = (props: IAttachedAgreementsProps) => {
    const dispatch = useDispatch();
    const appContext = useSelector((state: IRootState) => state.appContext);

    const [aHeight, setAHeight] = useState<string | number>(0);

    // Toggle Methods   
    const toggleContracts = () => {
        const newHeight = aHeight === 'auto' ? 0 : 'auto';
        setAHeight(newHeight);
    };
    
    const navToAcquisition = (contractId: number, contractType: string) => {
        if (props.ownerLookupId !== undefined) {
            let parentPath = `/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}`;

            let navPath = AgreementUtil.navToAcquisition(props.ownerLookupId, contractId, contractType);
    
            dispatch(push(parentPath + navPath));
        }
    };

    // React Elements
    const contractCard = (contract: ContractOwnershipList, _index: number) => {
        let typeString = 'N/A';
        let aType = contract.agreementType?.trim();
        if (aType?.length > 0) {
            typeString = aType;
            let sType = contract.subType?.trim();
            typeString += sType?.length > 0 ? ` - ${sType}` : '';
        }

        return (
            <div
                style={{ backgroundColor: contract.isActiveLease ? '#ffff7d' : 'white', borderBottom: '1px solid grey', padding: '.5rem', display: 'flex' }}
                onClick={() => contract.isGeneratedAgreement && contract.isInHand !== true
                    ? navToAcquisition(contract.agreementId, contract.agreementType)
                    : props.navToLeasehold(contract.ownershipId, contract.agreementId, contract.agreementholdId, contract.agreementType)
                }
                className="clickable"
                key={`${contract.agreementId}-${contract.agreementholdId}-${contract.ownershipId}`}
            >
                <div style={{ width: props?.shortList ? '40%' : '20%' }}>{typeString}</div>

                <div style={{ width: props?.shortList ? '20%' : '15%' }}>{contract.agreementNumber ? contract.agreementNumber : contract.leaseNumber || 'N/A'}</div>

                <div style={{ width: props?.shortList ? '20%' : '15%' }}>
                    {contract.instrumentNumber
                        ? contract.volume && contract.page
                            ? `${contract.volume} / ${contract.page} | ${contract.instrumentNumber}`
                            : contract.instrumentNumber
                        : contract.volume && contract.page
                            ? `${contract.volume} / ${contract.page}`
                            : 'N/A'
                    }
                </div>

                {!props?.shortList && (
                    <>
                        <div style={{ width: '20%' }}>{contract.agreementDate ? moment(contract.agreementDate)?.format('MM/DD/YYYY') : 'N/A'}</div>

                        <div style={{ width: '20%' }}>{contract.originalLessor || 'N/A'}</div>

                        <div style={{ width: '20%' }}>{contract.originalLessee || 'N/A'}</div>
                    </>
                )}

                <div style={{ width: '10%' }}>{contract.isTopLease ? 'Top Lease' : contract.isActiveLease ? 'Active' : 'Historical'}</div>
            </div>
        );
    };
    
    const contractCardContainer = () => {
        let fullList = props.attachedAgreements
            .filter((l) => l.isInHand === true || !l.isGeneratedAgreement)
            .sort((a, b) => { // sort by Agreement / Ownership Type first
                if (a.agreementType > b.agreementType) {
                    return -1;
                }
                if (a.agreementType < b.agreementType) {
                    return 1;
                }
                return 0;
            });

        if (fullList.length > 0) {
            return fullList.sort((a, b) => {
                if (a.isActiveLease > b.isActiveLease) {
                    return -1;
                }
                if (a.isActiveLease < b.isActiveLease) {
                    return 1;
                }
                return 0;
            })
            .map((contract: ContractOwnershipList, index) => {
                return contractCard(contract, index);
            });
        } else {
            return <div style={{ textAlign: 'center' }}>--No InHanded Contract Ownerships have been attached to this Ownership--</div>;
        }
    };

    const contractList = () => {
        return (
            <div style={{ marginBottom: '1rem' }}>
                <div style={{ display: 'flex', padding: '.5rem' }}>
                    <div style={{ width: props?.shortList ? '40%' : '20%' }}>Agreement Type</div>
                    <div style={{ width: props?.shortList ? '20%' : '15%' }}>Agreement Number</div>
                    <div style={{ width: props?.shortList ? '20%' : '15%' }}>Vol/Page | Inst#</div>
                    {!props?.shortList && (
                        <>
                            <div style={{ width: '20%' }}>Agreement Date</div>
                            <div style={{ width: '20%' }}>Lessor</div>
                            <div style={{ width: '20%' }}>Lessee</div>
                        </>
                    )}
                    <div style={{ width: '10%' }}>Status</div>
                </div>

                <div>{contractCardContainer()}</div>
            </div>
        );
    };

    return (
        
        <div>
            {props.attachedAgreements?.length > 0 && (
                <>
                    <div className="clickable" onClick={toggleContracts} style={{ marginBottom: '1rem', marginLeft: '1rem' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '1.75rem' }}>{aHeight === 'auto' ? '-' : '+'}</span>
                        {`Agreements (${props.attachedAgreements?.length})`}
                    </div>
                    <AnimateHeight duration={300} height={aHeight}>
                        {contractList()}
                    </AnimateHeight>
                </>
            )}
            
            {props.attachedAgreements && props.attachedAgreements?.length === 0 && (
                <Card>
                    <p style={{ marginLeft: '1rem' }}>No Agreements for this Owner</p>
                </Card>
            )}
        </div>
    );
};

export default AttachedAgreements;


// WEBPACK FOOTER //
// ./src/components/project/sections/owners/AttachedAgreements.tsx